module.exports = __webpack_public_path__ + "static/media/VN.ba059bf3.svg";